<template>
    <v-layout>
        <v-navigation-drawer
                v-model="drawer"
                fixed
                clipped
                class="secondary"
                app>
            <v-list class="pt-0">
                <router-link :key="i" :to="item.to" v-for="(item, i) in menu" replace>
                    <v-list-tile class="icon_menu" :class="$route.path.startsWith(item.to) ? 'selected' : null">
                        <v-list-tile-action>
                            <v-icon class="white--text">{{ item.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content class="white--text">
                            <v-list-tile-title>
                                {{ item.text.toUpperCase() }}
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </router-link>
            </v-list>

            <v-list class="pt-0" v-if="perfil.permitir_cadastro_distribuicao_leads || perfil.permitir_remanejamento_leads">
                <v-list-group class="icon_menu" style="margin-top: -0.7rem;" >
                    <template v-slot:activator>
                        <v-icon class="lnr lnr-list white--text ml-3"></v-icon>
                        <v-list-tile class="white--text" slot="activator" >
                            <v-list-tile-title  class="white--text config">
                                LEADS
                            </v-list-tile-title>
                        </v-list-tile>
                    </template>
                    <router-link :key="i" :to="item.to" replace v-for="(item, i) in menuDropDownLeads" class="pl-0">
                        <v-list-tile :class="$route.path.startsWith(item.to) ? 'selected' : null" class="icon_menu">
                            <v-list-tile-action >
                                <v-list-tile-title  class="white--text ml-3" style="font-size: 35px;">-</v-list-tile-title>
                            </v-list-tile-action>
                            <v-list-tile-content class="white--text">
                                <v-list-tile-title  >
                                    {{ item.text.toUpperCase() }}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </router-link>
                </v-list-group>
            </v-list>

            <v-list class="pt-0" v-if="perfil.permitir_configuracao_expiracao_sla || perfil.permitir_configuracao_email || perfil.permitir_configuracao_mes_comercial">
                <v-list-group class="icon_menu" style="margin-top: -0.7rem;" >
                    <template v-slot:activator>
                        <v-icon class="lnr lnr-cog white--text ml-3"></v-icon>
                        <v-list-tile class="white--text" slot="activator" >
                            <v-list-tile-title  class="white--text config">
                                Configurações
                            </v-list-tile-title>
                        </v-list-tile>
                    </template>
                    <router-link :key="i" :to="item.to" replace v-for="(item, i) in menuDropDown" class="pl-0">
                        <v-list-tile :class="$route.path.startsWith(item.to) ? 'selected' : null" class="icon_menu">
                            <v-list-tile-action >
                                <v-list-tile-title  class="white--text ml-3" style="font-size: 35px;">-</v-list-tile-title>
                            </v-list-tile-action>
                            <v-list-tile-content class="white--text">
                                <v-list-tile-title  >
                                    {{ item.text.toUpperCase() }}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </router-link>
                </v-list-group>
            </v-list>

        </v-navigation-drawer>
        <v-toolbar color="white" class="toolbar white--text" app fixed clipped-left>
            <div class="toolbar_menu_header primary"></div>
            <v-toolbar-side-icon class="toolbar_icon white--text" @click="drawer = !drawer"></v-toolbar-side-icon>
            <span class="title logo-menu-wrapper"><img class="logo-menu" v-bind:src="require(`@/assets/img/${logo}`)"/></span>
            <v-breadcrumbs class="ml-4" :items="breadcrumbs">
                <v-breadcrumbs-item class="breadcrumb-item" :disabled="true" slot="item" slot-scope="{ item }">
                    {{ item }}
                </v-breadcrumbs-item>
            </v-breadcrumbs>
            <v-spacer></v-spacer>
            <v-label>
                <v-layout row align-center class="pa-3">
                    <v-icon color="primary" class="mr-2">ol-business_center</v-icon>
                    <m-select class="select_unidade"
                              hide-details
                              :value="id_unidade_negocio"
                              placeholder="Unidade de negócio"
                              :items="unidades_negocio"
                              item-text="nome"
                              item-value="id_unidade_negocio"
                              v-on:change="alterarUnidade"
                              outline
                    >
                    </m-select>
                </v-layout>
            </v-label>
            <v-label>
                <v-layout row align-center>
                    <v-icon color="primary" class="mr-1">ol-perm_identity</v-icon>
                    Olá {{nome_usuario}}, seja bem-vindo
                </v-layout>
            </v-label>
            <div class="ml-4"></div>
            <v-label @click="logout">
                <v-layout class="pointer" row align-center>
                    <v-icon color="primary" class="mr-1 opacity05">ol-power_settings_new</v-icon>
                    Sair
                </v-layout>
            </v-label>
        </v-toolbar>
        <v-content class="app-content">
            <router-view class="router-view"></router-view>
        </v-content>
    </v-layout>
</template>

<script>
import { alert, error } from '../plugins/helpers'
import { mapState, mapMutations } from 'vuex'
import { find } from 'lodash'
import { events } from '../plugins/events'

export default {
  computed: {
    nome_usuario () {
      return this.$session.get('nome').split(' ')[0]
    },
    ...mapState(['breadcrumbs', 'perfil', 'id_unidade_negocio']),
    menu () {
      const perfil = this.perfil
      const menuApresentar = []

      if (perfil.permitir_cadastro_comunicado) {
        menuApresentar.push({ icon: 'lnr-license', ...this.menuRoute('comunicados') })
      }

      if (perfil.permitir_cadastro_hierarquia) {
        menuApresentar.push({ icon: 'lnr-briefcase', ...this.menuRoute('hierarquias') })
      }

      if (perfil.permitir_cadastro_perfil) {
        menuApresentar.push({ icon: 'lnr-users', ...this.menuRoute('perfis') })
      }

      if (perfil.permitir_cadastro_regiao) {
        menuApresentar.push({ icon: 'lnr-map-marker', ...this.menuRoute('regioes') })
      }

      if (perfil.permitir_cadastro_unidades) {
        menuApresentar.push({ icon: 'lnr-apartment', ...this.menuRoute('unidades_negocio') })
      }

      if (perfil.permitir_cadastro_usuario) {
        menuApresentar.push({ icon: 'lnr-user', ...this.menuRoute('usuarios') })
      }

      if (perfil.permitir_historico_leads) {
        menuApresentar.push({ icon: 'lnr-layers', ...this.menuRoute('historico_leads') })
      }

      return menuApresentar
    },
    menuDropDown () {
      const perfil = this.perfil
      const subMenuRetornar = []

      if (perfil.permitir_configuracao_expiracao_sla) {
        subMenuRetornar.push({ ...this.menuRoute('expiracao_sla') })
      }

      if (perfil.permitir_configuracao_mes_comercial) {
        subMenuRetornar.push({ ...this.menuRoute('mes_comercial') })
      }

      return subMenuRetornar
    },
    menuDropDownLeads () {
      const perfil = this.perfil
      const subMenuRetornarLeads = []

      if (perfil.permitir_cadastro_distribuicao_leads) {
        subMenuRetornarLeads.push({ ...this.menuRoute('leads') })
      }

      if (perfil.permitir_remanejamento_leads) {
        subMenuRetornarLeads.push({ ...this.menuRoute('remanejamento_leads') })
      }

      return subMenuRetornarLeads
    }
  },
  methods: {
    ...mapMutations(['setPerfil', 'setUnidadeNegocio']),
    menuRoute (name) {
      const route = this.$router.resolve({ name }).route
      return { text: route.meta.title, to: route.path, permissao_nome: route.meta.permissao_nome }
    },
    logout () {
      alert({
        text: 'Tem certeza que deseja sair do sistema?',
        buttons: {
          'Cancelar': () => true,
          'Sair': () => this.$router.replace({ name: 'logout', params: { force: 'true' } })
        }
      })
    },
    alterarUnidade (id_unidade_negocio) {
      const unidade = find(this.unidades_negocio, ['id_unidade_negocio', id_unidade_negocio])

      if (!unidade) { return }

      let id_usuario = this.$session.get('id_usuario')
      this.$http.get('admin/perfis/unidadeatual', { params:
                  { id_unidade_negocio: unidade.id_unidade_negocio,
                    id_usuario: id_usuario } })
        .then((r) => {
          const perf = r.data['Perfil']
          const painel_lead = r.data['PainelLead']
          if (perf) {
            this.setUnidadeNegocio(unidade.id_unidade_negocio)

            this.$session.set('nome_unidade', unidade.nome)
            this.$session.set('primary', unidade.primary)
            this.$session.set('secondary', unidade.secondary)
            this.$session.set('logo', unidade.imagem_logo)
            this.$session.set('accent', unidade.accent)
            this.$session.set('painel_lead', painel_lead)
            this.setPerfil(perf)
            this.loadCores()

            if (this.id_unidade_negocio_selecionado !== id_unidade_negocio && this.id_unidade_negocio_selecionado !== 0) {
              this.$router.go()
            }
            this.id_unidade_negocio_selecionado = id_unidade_negocio
          } else {
            alert({
              text: 'Você não possui perfil de acesso a essa associada?',
              buttons: {
                'OK': () => {
                  const unidade = find(this.unidades_negocio, ['id_unidade_negocio', this.id_unidade_negocio_selecionado])
                  this.setUnidadeNegocio(unidade.id_unidade_negocio)
                  this.$router.go()
                }
              }
            })
          }
        })
    },
    loadUnidadesNegocioList (id_usuario) {
      this.$http.get(`/admin/usuarios/unidadesnegocio`, { params: { id_usuario: id_usuario } }).then((r) => {
        r.data.forEach(unidade => {
          this.unidades_negocio.push(unidade)
        })

        this.alterarUnidade(this.id_unidade_negocio)
      }).catch(this.fail)
    },
    fail (err) {
      error(err, 'Não foi possível recuperar as informações.')
    },
    loadCores () {
      if (this.$session.get('primary')) {
        this.logo = this.$session.get('logo')
        this.$vuetify.theme.primary = this.$session.get('primary')
        this.$vuetify.theme.secondary = this.$session.get('secondary')
        this.$vuetify.theme.accent = this.$session.get('accent')
      }
    }
  },
  mounted () {
    const id_usuario = this.$session.get('id_usuario')
    this.loadUnidadesNegocioList(id_usuario)
    this.loadCores()
    events.$on('atualizar-unidade', (id_usuario) => {
      this.unidades_negocio = []
      this.loadUnidadesNegocioList(id_usuario)
    })
  },
  data: () => ({
    drawer: null,
    id_unidade_negocio_selecionado: 0,
    unidades_negocio: [],
    logo: 'unifisa-logo-menu.png'
  })
}
</script>

<style>
    .toolbar .select_unidade.v-text-field.v-text-field--outline .v-input__slot {
        min-height: auto;
        max-width: 220px;
    }

    .toolbar .select_unidade.select_unidade.v-text-field.v-text-field--solo .v-input__control {
        min-height: auto;
    }

    .toolbar > div {
        padding-left: 0;
    }

    .v-breadcrumbs li, .v-breadcrumbs li a {
        font-size: 18px;
        color: rgba(0, 0, 0, .54) !important;
    }

    .v-breadcrumbs li:last-child a {
        font-weight: bold;
    }
    .v-list__group__header--active .v-list__group__header__append-icon .v-icon{
        color: #FFFFFF;
    }
    .v-list__group__header .v-list__group__header__append-icon .v-icon{
        color: #FFFFFF;
    }
    .v-list__group__items{
        background-color: rgba(0,0,0,0.3);
    }

</style>

<style scoped>
    .app-content {
        background: #F5F5F5;
    }

    .toolbar .title {
        z-index: 1;
    }

    .toolbar.v-toolbar {
        box-shadow: 0 0 10px 1px rgba(0, 0, 0, .1);
    }

    .toolbar_menu_header {
        position: absolute;
        height: 100%;
        width: 300px;
    }

    .icon_menu {
        padding-top: 0.8rem;
        padding-bottom: 0.8rem;
        transition: all ease 0.3s;
    }

    .icon_menu.selected {
        background-color: #00000022
    }

    .icon_menu:hover {
        background-color: #FFFFFF22
    }

    .logo-menu-wrapper {
        width: 252px;
        height: 100%;
        padding: 7px 0;
    }

    .logo-menu {
        width: 100%;
        max-height: 100%;
        object-fit: contain;
        object-position: left;
    }

    .opacity05:hover {
        opacity: 0.5;
    }
    .config{
        margin-left: 18px!important;
        font-size:   16px;
    }
</style>
